import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { DummyComponent } from '../../../shared/dummy.component';
import { ContactListComponent } from '../../contact/contact/contact-list.component';
import { AdminConst } from '../const';
import { AdminContactModel } from './admincontact.model';
import { AdminContactService } from './admincontact.service';

@Component({
    selector: 'convfact-admincontact-import',
    templateUrl: './admincontact-import.component.html',
    styleUrls: ['./admincontact.component.css'],
    standalone: false
})

export class AdminContactImportComponent {

  constructor(
    private admincontactService: AdminContactService,
    public dialogRef: MatDialogRef<ContactListComponent>,
    public snackBar: MatSnackBar,
    public dialog: MatDialog,
    public dummy: DummyComponent
  ) { }

  dataReady = false;
  working = false;
  dataSource: AdminContactModel[] = [];
  headerTable: any[] = AdminConst.headerTableContacts;

  closeDialog() {
    this.dialogRef.close();
    this.dummy.redirectTo('/admin/contacts');
  }

  downloadTemplate() {
    const win = window.open('https://drive.google.com/u/0/uc?id=1AlttrJGESopYlfnsIFv-yhJ6tq_aFJ44&export=download', '_blank');
    win.focus();
  }

  downloadDemoTemplate() {
    const win = window.open('https://drive.google.com/u/1/uc?id=15qBLy9wgb0JrSkEtWLE1oNaVeWNQB66N&export=download', '_blank');
    win.focus();
  }

  displayInfo(message: string): void {
    const options = new MatSnackBarConfig();
    options.duration = 10000;
    options.panelClass = ['custom-snackbar', 'custom-snackbar-container']; this.snackBar.open(message, '', options);
  }

  addContacts() {
    this.working = true;
    this.admincontactService.importData(this.dataSource).then(response => {
      this.displayInfo(response);
      this.closeDialog();
      this.working = false;
    })
  }

  fileChange(event) {
    const fileList: FileList = event.target.files;
    if (fileList.length > 0) {
      const file: File = fileList[0];
      const formData: FormData = new FormData();
      formData.append('file', file, file.name);
      this.admincontactService.importContacts(formData).then(response => {
        this.dataSource = response;
        this.dataReady = true;
      })
    }
  }

}
